import { MINUTE_IN_SECONDS } from '@packages/shared/core/common/constants/time';

export function getCurrentUtcOffsetInSeconds(): number {
  if (typeof window === 'undefined') {
    return 0;
  }

  const offsetInMinutes = -new Date().getTimezoneOffset();

  return offsetInMinutes * MINUTE_IN_SECONDS;
}
